import Link from "next/link";
import { Container, Card, Row, Col } from "react-bootstrap";
import Carousel from "@brainhubeu/react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";
import styles from "../styles/Home.module.css";
import Image from "next/image";

import { Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

function RelatedProducts(props) {
  const breakpoints = {
    320: {
      slidesPerView: 2,
    },
    480: {
      slidesPerView: 2,
    },
    640: {
      slidesPerView: 3,
    },
    992: {
      slidesPerView: 4,
    },
    1100: {
      slidesPerView: 6,
    },
  };
  const products = props.relatedProducts;
  return (
    <div>
      <h2 className="text-center mb-3 fw-600 text-dark">Related Products</h2>
      {products ? (
        products.length > 1 ? (
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={6}
            autoplay={{ delay: 3000 }}
            pagination={{ clickable: true }}
            breakpoints={breakpoints}
          >
            {products.map((product) => (
              <SwiperSlide key={product.id}>
                <div className="text-center inListing model-list">
                  <Link
                    href={`/${product.category_slug}/${product.brand_slug}/${product.slug}`}
                  >
                    <a>
                      <div className="p-3 rounded-lg bg-white shadow-default">
                        <div className="mb-2">
                          <div
                            className="mb-0 d-flex align-items-center justify-content-center"
                            style={{ width: "150px", height: "150px" }}
                          >
                            <Image
                              src={product.images[0].filename}
                              width="100%"
                              height="100%"
                            />
                          </div>
                        </div>
                        <div style={{ fontSize: "12px" }}>{product.name}</div>
                      </div>
                    </a>
                  </Link>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <Row className="justified-content-center">
            <Col sm={2}>
              {products.map((product) => (
                <div
                  className="p-3 rounded-lg bg-white shadow-default"
                  key={product.id}
                >
                  <div className="">
                    <Link
                      href={`/${product.category_slug}/${product.brand_slug}/${product.slug}`}
                    >
                      <a>
                        <div className="mb-2">
                          <div
                            className="mb-0 d-flex align-items-center justify-content-center"
                            style={{ width: "150px", height: "150px" }}
                          >
                            <Image
                              src={product.images[0].filename}
                              width="100%"
                              height="100%"
                            />
                          </div>
                        </div>
                        <div>{product.name}</div>
                      </a>
                    </Link>
                  </div>
                </div>
              ))}
            </Col>
          </Row>
        )
      ) : (
        <div className="text-center">Products Not Found!</div>
      )}
    </div>
  );
}

export default RelatedProducts;
